import { Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getGremialistas } from "../../../../../redux/actions/rgrl";
import FormikActions from "../../../../commons/formik/FormikActions";
import { StyledRgrl } from "../../../../styled/Prevencion";

const initialValues = {
  id: "",
  nombre: "",
};

const validationSchema = Yup.object().shape({
  id: Yup.string().required("Campo obligatorio").nullable(),
});

const AddGremioDialog = ({ open, handleClose, handleSumbit }) => {
  const dispatch = useDispatch();
  const gremialistas = useSelector((state) => state.rgrl.gremialistas?.data);

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Seleccionar Gremialista</DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSumbit(values)}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => (
          <Form>
            <DialogContent>
              <div>
                <StyledRgrl.Input
                  name="id"
                  label="Gremios"
                  options={gremialistas}
                  renderOption={(option) => option.nombre}
                  filterOptions={(option) => option.nombre}
                  getOptions={() => dispatch(getGremialistas())}
                  callBack={(value) => {
                    if (value) {
                      setFieldValue("nombre", value.nombre);
                    }
                  }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <FormikActions handleCancel={handleClose}></FormikActions>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddGremioDialog;
